export const CREATOR = {
	Default: 'Default',
	Blackshark: 'Blackshark',
};
